import { render } from "./TeamDirectoryView.vue?vue&type=template&id=ec46ea98&scoped=true"
import script from "./TeamDirectoryView.vue?vue&type=script&lang=js"
export * from "./TeamDirectoryView.vue?vue&type=script&lang=js"

import "./TeamDirectoryView.vue?vue&type=style&index=0&id=ec46ea98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec46ea98"]])

export default __exports__